import React from 'react'

import { Icon } from '../../components/Icon'
import { ReactComponent as LogoSvg } from '../../assets/svgs/logos/Logo.svg'

import PrivacyPolicy from './PrivacyPolicy'
import { useNavigate } from 'react-router-dom'

const PrivacyPage = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray1 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mx-5 sm:mx-auto sm:w-full sm:max-w-lg flex">
        <div className="flex gap-4 flex-1 ">
          <LogoSvg width={130} height={36} />
        </div>
      </div>
      <div className="mx-auto mt-8 w-[60%] ">
        <PrivacyPolicy />
        <div className="sm:mx-auto w-full h-auto px-8 my-4 py-6 rounded-[1rem] gap-16 bg-gray2">
          <div className="flex gap-3 items-center">
            <Icon
              name={'IconCheckMonogram'}
              width={16}
              height={16}
              strokeWidth={1}
            />
            <div
              className="cursor-pointer"
              onClick={() => navigate('/privacy-policy')}
            >
              <p className="font-medium text-xs text-text1">Privacy Policy</p>
            </div>
            <div
              className="cursor-pointer"
              onClick={() => navigate('/terms-condiditions')}
            >
              <p className="font-medium text-xs text-text1">
                Terms & Conditions
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="font-medium text-xs text-text3">
              © 2025 Streamlearn Ltd. All rights reserved. 360 Safeguarding is
              a trading name of Streamlearn Ltd. Company No. 12180453.
              Registered office: Axis 19 Mallard Way, Riverside Business Park,
              Swansea Vale, Swansea, SA7 0AJ.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPage
